import { FC } from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { CHART_COLORS, formatEuro } from "../common/constants";
import { SpendingDataPoint } from "../common/types";

type SpendingEvolutionChartProps = {
  data: SpendingDataPoint[];
};

export const SpendingEvolutionChart: FC<SpendingEvolutionChartProps> = ({
  data,
}) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip
          formatter={(value: any, name: string) => [
            name === "total_spent_euro" ? formatEuro(value) : value,
            name === "total_spent_euro" ? "Revenus (€)" : name,
          ]}
        />
        <Legend />
        <Line
          type="monotone"
          dataKey="total_spent_euro"
          name="Revenus (€)"
          stroke={CHART_COLORS.totalSpent}
          strokeWidth={3}
        />
        <Line
          type="monotone"
          dataKey="unique_buyers"
          name="Acheteurs uniques"
          stroke={CHART_COLORS.uniqueBuyers}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
